import PropTypes from 'prop-types';

const Input = ({
  label,
  type,
  labelPlacement = 'top',
  placeholder,
  value,
  onChange,
  required,
  error,
  inputClassName,
  labelClassName,
  parentClassName,
  errorClassName,
  disabled,
  ...rest
}) => {
  return (
    <div
      className={`flex ${labelPlacement === 'top' ? 'flex-col' : 'items-center gap-8 w-full'} ${parentClassName} text-base`}
    >
      {label && (
        <label className={`text-gray-700 font-bold mb-2 ${labelClassName}`}>
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <input
        className={`border border-gray-400 text-black p-2 rounded-lg  ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-70' : ''} ${labelPlacement === 'top' ? '' : 'w-full'} ${inputClassName} ${
          error ? 'border-red-500' : ''
        }`}
        type={type}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={onChange}
        required={required}
        disabled={disabled}
        onKeyDown={(e) => {
          if (type === 'number' && ['e', 'E', '+', '-'].includes(e.key)) {
            e.preventDefault();
          }
        }}
        {...rest}
      />
      {error && (
        <p className={`mt-1 text-base text-red-500 ${errorClassName}`}>
          {typeof error === 'object' ? error.message : error}
        </p>
      )}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  error: PropTypes.string,
  inputClassName: PropTypes.string,
  labelPlacement: PropTypes.string,
  labelClassName: PropTypes.string,
  parentClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Input;

